import httpClient from '~/http';
import { PrinterItem } from '../../types';

export const createPrinter = (values: PrinterItem) => {
  return httpClient.post('/api/v2/printers', values);
};
